(() => {
  document.addEventListener('shopify:section:unload', (event) => {
    const sectionId = event.detail?.sectionId || event.target?.id?.replace('shopify-section-', '');
    if (!sectionId) return;
    document
      .querySelectorAll('body > quick-add-modal[data-section], body > modal-dialog.quick-add-modal[data-section]')
      .forEach((modal) => {
        if (modal.dataset.section !== sectionId) return;
        if (modal.hasAttribute('open')) modal.hide?.(true);
        modal.remove();
      });
  });

  const loadNextPage = async (button) => {
    const nextUrl = button.dataset.nextUrl;
    if (!nextUrl || button.classList.contains('is-loading')) return;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');
    const original = button.textContent;
    button.textContent = 'Loading…';

    try {
      const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const currentGrid = document.querySelector('#product-grid');
      const nextGrid = documentFragment.querySelector('#product-grid');
      nextGrid?.querySelectorAll(':scope > li').forEach((item) => currentGrid?.append(item));

      const nextButton = documentFragment.querySelector('[data-sb-load-more]');
      const pagination = documentFragment.querySelector('.pagination-wrapper');
      const currentPagination = document.querySelector('.pagination-wrapper');
      if (currentPagination && pagination) currentPagination.replaceWith(pagination);
      else currentPagination?.remove();

      if (nextButton?.dataset.nextUrl) {
        button.dataset.nextUrl = nextButton.dataset.nextUrl;
        button.textContent = original;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      } else {
        button.closest('.sb-load-more')?.remove();
      }
    } catch (_error) {
      button.textContent = 'Try again';
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-sb-load-more]');
    if (!button) return;
    event.preventDefault();
    loadNextPage(button);
  });
})();
